import axios from 'axios';

const translateIds = (data) => axios.post('/integrations/internal/translate_ids', data);

const getReportParams = (accGuid) =>
  axios.get(`/integrations/internal/external_report_params/${accGuid}`);

export default {
  translateIds,
  getReportParams,
};
